//  Name: message-system
import EventBus from '@/helpers/event-bus'

// TODO: Hacer que las notificaciones se vean una vez y luego al cambiar de sitio
// desaparecan de manera automática
export default {
  props: {
    size: {
      type: String
    }
  },
  data () {
    return {
      message: {
        text: null,
        type: 'primary',
        classes: {}
      },
      view: 0
    }
  },
  watch: {
    '$route': function (val) {
      console.log('Counter view ' + this.view);
      this.view++
    },
    'size': function (val) {
      if (val === 'small') {
        this.message.classes['is-small'] = true
      }
    }
  },
  methods: {
    waitMessage () {
      this.showMessage({message: '<i class="fa fa-spin fa-spinner"></i> Por favor espere...'})
    },
    errorMessage (text) {
      var msg = {
        type: 'danger',
        message: text
      }
      this.showMessage(msg)
    },
    successMessage(text) {
      var msg = {
        type: 'success',
        message: text
      }
      this.showMessage(msg)
    },
    warningMessage(text) {
      var msg = {
        type: 'warning',
        message: text
      }
      this.showMessage(msg)
    },
    showMessage (data) {
      this.view = 1
      this.message.classes = {}

      this.message.text = data.message
      var type = 'is-' + this.message.type
      if (data.type) {
        type = 'is-' + data.type
      }
      if (this.size === 'small') {
        this.message.classes['is-small'] = true
      }
      this.message.classes[type] = true
    },
    dismissMessage () {
      this.message =  {
        text: null,
        type: 'primary',
        classes: {}
      },
      this.view = 0
    },
    close () {
      this.message = null
      this.view = 0
    }
  },
  mounted () {
    EventBus.$on('showMessage', this.showMessage)
    EventBus.$on('waitMessage', this.waitMessage)
    EventBus.$on('errorMessage', this.errorMessage)
    EventBus.$on('successMessage', this.successMessage)
    EventBus.$on('warningMessage', this.warningMessage)
    EventBus.$on('dismissMessage', this.dismissMessage)
  },
  beforeDestroy () {
    EventBus.$off('showMessage', this.showMessage)
    EventBus.$off('waitMessage', this.waitMessage)
    EventBus.$off('errorMessage', this.errorMessage)
    EventBus.$off('successMessage', this.successMessage)
    EventBus.$off('warningMessage', this.warningMessage)
    EventBus.$off('dismissMessage', this.dismissMessage)
  }
}



// WEBPACK FOOTER //
// ./src/components/message-system/script.js